<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("eserman module settings") }}
      </h1>
    </div>

    <!-- <div class="title is-5">{{ $t("availability schedule") }}</div>
    <div class="button is-primary is-rounded" @click="availability">
      <span class="icon"><i class="fa fa-calendar"></i></span>
      <span>{{ $t("availability") }}</span>
    </div> -->

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive_little_jar"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive_little_jar">{{
            $t("integrate")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for photos')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("outbox module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_outbox"
            name="chk_integrate_outbox"
            v-model="meta.integrate_outbox"
          />
          <label for="chk_integrate_outbox">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('template for email billing')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="qr_template_changed"
            ref="qr_template_dropdown"
          />
        </div>
      </div>
    </div>

    <h1 class="title is-5">{{ $t("fel module integration") }}</h1>
    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_fel"
            name="chk_integrate_fel"
            v-model="meta.integrate_fel"
          />
          <label for="chk_integrate_fel">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('fel emitter')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/fel/emitter/catalog"
            name_field="name"
            value_field="emitter_id"
            @selected="fel_emitter_changed"
            ref="fel_emitter_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("default country") }}</label>
          <input type="text" class="input" v-model="meta.fel_default_country" />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("default zip code") }}</label>
          <input
            type="text"
            class="input"
            v-model="meta.fel_default_zip_code"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('template for billing')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="billing_template_changed"
            ref="billing_template_dropdown"
          />
        </div>
      </div>
    </div>

    <service-types-datatable />

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- <availability-modal ref="availability_modal" @save="update_availability" /> -->
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import ServiceTypesDatatable from "./service_types_datatable/Index.vue";
// import AvailabilityModal from "./availability_modal/Index.vue";

export default {
  name: "EsermanSettings",
  components: {
    GenericDropdown,
    ServiceTypesDatatable,
    // AvailabilityModal,
    GenericUploader,
  },
  data() {
    return {
      meta: {
        payment_methods: [],
      },
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    account_type_changed(value) {
      this.meta.account_type_id = value.type_id;
    },
    movement_type_changed(value) {
      this.meta.movement_type_id = value.movement_type_id;
    },
    payment_movement_type_changed(value) {
      this.meta.payment_movement_type_id = value.movement_type_id;
    },
    drive_changed(value) {
      this.meta.drive_id = value.drive_id;
    },
    drive_qr_changed(value) {
      this.meta.drive_qr_id = value.drive_id;
    },
    qr_template_changed(value) {
      this.meta.qr_template_id = value.template_id;
    },
    availability() {
      let v = this;
      v.$refs.availability_modal.show_modal(v.meta);
    },
    update_availability(data) {
      let v = this;
      v.meta.availability = data;
    },
    error_uploading(error) {
      console.error("error_uploading", error);
      // let v = this;
      // v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      let server_response = JSON.parse(response.serverId);
      v.meta.rules_pdf = server_response;
      // v.$refs.generic_uploader.clear();
      // v.init();
    },
    add_payment_method() {
      let v = this;
      v.meta.payment_methods.push({
        name: "",
        ask_for_document_number: false,
      });
    },
    check_customer_account_existance() {
      let v = this;
      post("/pilates_member/account-existance")
        .then((response) => {
          success_message(v.$t("every customer has an account"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
    fel_emitter_changed(value) {
      this.meta.fel_emitter_id = value.emitter_id;
    },
    billing_template_changed(value) {
      this.meta.billing_template_id = value.template_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.account_type_id) {
            v.$refs.account_type_dropdown.set_value(conf.account_type_id);
          }
          if (conf.movement_type_id) {
            v.$refs.movement_type_dropdown.set_value(conf.movement_type_id);
          }
          if (conf.payment_movement_type_id) {
            v.$refs.payment_movement_type_dropdown.set_value(
              conf.payment_movement_type_id
            );
          }
          if (conf.drive_id) {
            v.$refs.drive_dropdown.set_value(conf.drive_id);
          }
          if (conf.drive_qr_id) {
            v.$refs.drive_qr_dropdown.set_value(conf.drive_qr_id);
          }
          if (conf.qr_template_id) {
            v.$refs.qr_template_dropdown.set_value(conf.qr_template_id);
          }

          if (conf.fel_emitter_id) {
            v.$refs.fel_emitter_dropdown.set_value(conf.fel_emitter_id);
          }

          if (conf.billing_template_id) {
            v.$refs.billing_template_dropdown.set_value(
              conf.billing_template_id
            );
          }

          v.meta.payment_methods = conf.payment_methods || [];
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
